import React from "react";
import { bool } from "prop-types";

import useIsMobileDeviceSize from "src/shared/utilities/state/apollo/hooks/useIsMobileDeviceSize";

import { useDrawerContext } from "../../utilities/drawerHelpers";
import getDrawerTitle from "../../utilities/getDrawerTitle";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import { getTooltipText } from "../../utilities/segments";
import * as S from "./styled";

const Header = ({ inModalHeader, isModal }) => {
  const { contactFormType, listingId } = useFeatureState();
  const hasDrawerForm = useDrawerContext();
  const tooltipText = getTooltipText();
  const isMobileDeviceSize = useIsMobileDeviceSize();
  const showTooltip =
    (hasDrawerForm && !inModalHeader && listingId) || !hasDrawerForm;

  const formHeader =
    !hasDrawerForm || isModal
      ? "Contact an Expert"
      : getDrawerTitle({
          hasListing: Boolean(listingId),
          isModal: isModal || inModalHeader,
          type: contactFormType
        });

  return (
    <>
      {formHeader}
      {showTooltip && (
        <S.Tooltip
          $hasDrawerForm={hasDrawerForm}
          hasCloseButton={isMobileDeviceSize}
          inModalHeader={inModalHeader}
        >
          {tooltipText}
        </S.Tooltip>
      )}
    </>
  );
};

Header.propTypes = {
  inModalHeader: bool,
  isModal: bool
};

Header.defaultProps = {
  inModalHeader: false,
  isModal: false
};

export default Header;
